export default __webpack_public_path__ + "static/media/clem-onojeghuo.012fec78.jpg";